export const convertBooleanToCheckOrCross = (value: boolean) => (value ? '✔️' : '❌');
